import api from './apiClient';

export const eventsAPI = {
  async getByPlanner(plannerId) {
    try {
      const response = await api.get(`/events/planner/${plannerId}`);
      return response?.data ?? response;
    } catch (error) {
      console.error('Backend events API (planner) error:', error);
      throw error;
    }
  },

  async getAnalytics() {
    try {
      const response = await api.get('/event-stats');
      return response?.data ?? response;
    } catch (error) {
      console.error('Backend events analytics API error:', error);
      throw error;
    }
  },

  async getAll(filters = {}) {
    try {
      const response = await api.get('/events', { params: filters });
      return response?.data ?? response;
    } catch (error) {
      console.error('Backend events API error:', error);
      throw error;
    }
  },

  async getById(eventId) {
    try {
      const response = await api.get(`/events/${eventId}`);
      return response?.data ?? response;
    } catch (error) {
      console.error('Backend event details API error:', error);
      throw error;
    }
  },

  async delete(eventId) {
    try {
      const response = await api.delete(`/events/${eventId}`);
      return response?.data ?? response;
    } catch (error) {
      console.error('Backend delete event API error:', error);
      throw error;
    }
  },

  async getTicketTypes(eventId) {
    try {
      return await api.get(`/events/${eventId}/ticket-types`);
    } catch (error) {
      console.error('Backend event ticket types API error:', error);
      throw error;
    }
  },

  async create(eventData) {
    try {
      return await api.post('/events', eventData);
    } catch (error) {
      console.error('Backend create event API error:', error);
      throw error;
    }
  },

  async update(eventId, eventData) {
    try {
      return await api.put(`/events/${eventId}`, eventData);
    } catch (error) {
      console.error('Backend update event API error:', error);
      throw error;
    }
  },

  async addTicketTypeToEvent(eventId, ticketTypeData) {
    try {
      return await api.post(`/events/${eventId}/ticket-types`, ticketTypeData);
    } catch (error) {
      console.error('Backend add ticket type API error:', error);
      throw error;
    }
  },

  async createComplete(eventData, seatMapData, customTicketTypes = null) {
    try {
      const completeRequest = {
        event: eventData,
        seatMapData,
        customTicketTypes,
      };
      return await api.post('/events/complete', completeRequest);
    } catch (error) {
      console.error('Backend create complete event API error:', error);
      throw error;
    }
  },

  async finalizeSetup(eventId) {
    try {
      return await api.post(`/events/${eventId}/finalize`);
    } catch (error) {
      console.error('Backend finalize event setup API error:', error);
      throw error;
    }
  },

  async diagnoseInventory(eventId) {
    try {
      return await api.post(`/events/${eventId}/diagnose-inventory`);
    } catch (error) {
      console.error('Backend diagnose inventory API error:', error);
      throw error;
    }
  },

  async regenerateInventory(eventId) {
    try {
      return await api.post(`/events/${eventId}/regenerate-inventory`);
    } catch (error) {
      console.error('Backend regenerate inventory API error:', error);
      throw error;
    }
  },
};

export default eventsAPI;

